import React from "react";
import MainLayout from "../MainLayout";
import PayStubsMainV2 from "src/components/common/MainContent/Payroll/Paystubs/PayStubsMainV2";

const PayrollPaystubsPage = (props) => <MainLayout component={PayStubsMainV2} />;

export default PayrollPaystubsPage;
